import React from 'react';
import { CSSObject } from '@chakra-ui/react';
import { TBetReturn } from '../HeaderRow.types';
import IconSvg from '@/components/common/IconSvg';
import { HeaderRowSchema } from './HeaderRow.styles';

export const RunnerDetails: CSSObject = {
  color: 'white',
  fontWeight: 'bold',
  textShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
};
export const RunnerDescription: CSSObject = {
  fontWeight: 'bold',
  textShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
  fontSize: 'xs',
  color: 'white',
  span: {
    color: 'beta.300',
  },
  'span:nth-child(2)': {
    color: 'rgba(255, 255, 255, 0.24)',
  },
};
export const BetOdds: CSSObject = {
  color: 'white',
  textShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
  mb: '0.5',
};
export const TextBarrierNumber: CSSObject = {
  color: 'beta.300',
  fontSize: 'xs',
  fontWeight: 'bold',
};
export const BetReturn = (status: TBetReturn): CSSObject => ({
  label: status,
  bg: () => {
    switch (status) {
      case 'won':
        return 'green.400';
      case 'pending':
        return 'orange.400';
      default:
        return 'gray.300';
    }
  },
  color: () => {
    switch (status) {
      case 'won':
        return 'blackAlpha.700';
      case 'pending':
        return 'blackAlpha.800';
      default:
        return 'blackAlpha.800';
    }
  },
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  py: '0',
  h: '16px',
  lineHeight: '16px',
  fontSize: '9px',
});
export const HeaderSvg: CSSObject = {
  filter: 'drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.25))',
  boxSize: '5',
  color: 'beta.300',
};
export const BetMultiIcon: CSSObject = {
  boxSize: '5',
};
export const MultiIcon = () => (
  <IconSvg
    name="multi_betslip"
    className="svgIcon"
    color="beta.300"
    boxSize="5"
    mb="1.5"
  />
);
export const TextDescription: CSSObject = {
  textTransform: 'capitalize',
  '> a': {
    ml: '0',
  },
};
export const headerRowStyles: HeaderRowSchema = {
  originalOdds: {
    color: 'gray.100',
  },
  headerRowSvg: {
    fill: 'blackAlpha.800',
    color: 'beta.200',
  },
  mysteryBetIcon: { fill: 'beta.300' },
};
